__turbopack_context__.v({
  "eyebrowBlock": "BlockNews-module-scss-module__exTOXq__eyebrowBlock",
  "flushBottom": "BlockNews-module-scss-module__exTOXq__flushBottom",
  "flushTop": "BlockNews-module-scss-module__exTOXq__flushTop",
  "newsBlock": "BlockNews-module-scss-module__exTOXq__newsBlock",
  "storyBlock": "BlockNews-module-scss-module__exTOXq__storyBlock",
  "videoBlock": "BlockNews-module-scss-module__exTOXq__videoBlock",
});
